(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  if (!customElements.get('drawer-tabs')) {
    customElements.define(
      'drawer-tabs',
      class DrawerTabs extends HTMLElement {
        connectedCallback() {
          this.tabs = [...this.querySelectorAll('[role="tab"]')];
          this.tabs.forEach((tab) => tab.addEventListener('click', () => this.select(tab.dataset.tab)));

          this.addEventListener('keydown', (event) => {
            if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            const current = this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
            let next = current;
            if (event.key === 'ArrowLeft') next = (current - 1 + this.tabs.length) % this.tabs.length;
            if (event.key === 'ArrowRight') next = (current + 1) % this.tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.tabs.length - 1;
            this.select(this.tabs[next].dataset.tab);
            this.tabs[next].focus();
          });

          this.onTrigger = (event) => this.select(event.detail?.detail === 'wishlist' ? 'wishlist' : 'bag');
          document.addEventListener('dialog:trigger:cart-drawer', this.onTrigger);
        }

        disconnectedCallback() {
          document.removeEventListener('dialog:trigger:cart-drawer', this.onTrigger);
        }

        select(name) {
          this.tabs.forEach((tab) => {
            const selected = tab.dataset.tab === name;
            tab.setAttribute('aria-selected', String(selected));
            tab.tabIndex = selected ? 0 : -1;
            const panel = document.getElementById(tab.getAttribute('aria-controls'));
            if (panel) panel.hidden = !selected;
          });
          document.dispatchEvent(new CustomEvent('cart-drawer:tab', { detail: { tab: name } }));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-header"]) return;
  try {
    
  /* Mobile clamps the description to two lines; the toggle only shows when it overflows. */
  if (!customElements.get('collection-description')) {
    customElements.define(
      'collection-description',
      class CollectionDescription extends HTMLElement {
        connectedCallback() {
          this.text = this.querySelector('[data-description-text]');
          this.toggle = this.querySelector('[data-description-toggle]');
          this.toggle.addEventListener('click', () => {
            const open = !this.hasAttribute('open');
            this.toggleAttribute('open', open);
            this.toggle.setAttribute('aria-expanded', open);
            this.sync();
          });
          this.observer = new ResizeObserver(() => this.sync());
          this.observer.observe(this.text);
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }

        sync() {
          if (this.hasAttribute('open')) return;
          this.classList.toggle('is-truncated', this.text.scrollHeight > this.text.clientHeight + 1);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["film-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('film-banner')) {
    customElements.define(
      'film-banner',
      class FilmBanner extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('dialog');
          if (!this.dialog) return;
          this.video = this.dialog.querySelector('video');
          this.embed = this.dialog.querySelector('[data-film-embed]');

          this.querySelector('[data-film-open]').addEventListener('click', () => {
            this.dialog.showModal();
            document.body.style.overflowY = 'hidden';
            if (this.embed) this.embed.src = this.embed.dataset.src;
            this.video?.play().catch(() => {});
          });
          this.querySelector('[data-film-close]').addEventListener('click', () => this.dialog.close());
          this.dialog.addEventListener('close', () => {
            // Dropping the embed's src is the only way to stop a YouTube/Vimeo player.
            if (this.embed) this.embed.removeAttribute('src');
            this.video?.pause();
            document.body.style.overflowY = '';
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
window.document.onload = (event) => {
  if (window.location.href.includes('#recover')) {
    const event = new CustomEvent('dialog:trigger:recover');
    document.dispatchEvent(event);
  }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["numbered-list"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('numbered-list')) {
    customElements.define(
      'numbered-list',
      class NumberedList extends HTMLElement {
        connectedCallback() {
          this.media = this.querySelector('[data-numbered-media]');
          this.items = [...this.querySelectorAll('[data-numbered-item]')];
          if (!this.media || this.items.length < 2) return;
          this.slides = [...this.media.querySelectorAll('[data-index]')];
          this.index = 0;

          this.onScroll = () => {
            if (this.frame) return;
            this.frame = requestAnimationFrame(() => {
              this.frame = null;
              this.update();
            });
          };
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onScroll, { passive: true });

          if (window.Shopify?.designMode) {
            this.onBlockSelect = (event) => {
              const index = this.items.indexOf(event.target);
              if (index >= 0) this.activate(index);
            };
            document.addEventListener('shopify:block:select', this.onBlockSelect);
          }
          this.update();
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.onScroll);
          window.removeEventListener('resize', this.onScroll);
          cancelAnimationFrame(this.frame);
          if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
        }

        // The sticky image's top is the trigger line; on mobile it isn't sticky,
        // so fall back to the header height.
        triggerLine() {
          const top = parseFloat(getComputedStyle(this.media).top);
          if (!Number.isNaN(top)) return top;
          return parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sticky-header-height')) || 0;
        }

        update() {
          const line = this.triggerLine() + 1;
          let index = 0;
          this.items.forEach((item, i) => {
            if (item.getBoundingClientRect().top <= line) index = i;
          });
          this.activate(index);
        }

        activate(index) {
          if (index === this.index) return;
          this.index = index;
          this.slides.forEach((slide, i) => slide.toggleAttribute('data-active', i === index));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-process"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('process-steps')) {
    class ProcessSteps extends HTMLElement {
      connectedCallback() {
        this.copy = this.querySelector('[data-process-copy]');
        this.stage = this.querySelector('[data-process-stage]');
        this.texts = [...this.querySelectorAll('.process-text')];
        this.images = [...this.querySelectorAll('.process-image')];
        this.desktop = window.matchMedia('(min-width: 64rem)');
        this.images.forEach((image) => this.stage.append(image));

        this.mobileImages = [...this.querySelectorAll('[data-process-mobile-image]')];
        this.onDesktopChange = () => {
          this.sync();
          this.watchMobileImages();
        };
        this.desktop.addEventListener('change', this.onDesktopChange);

        this.observer = new IntersectionObserver((entries) => this.onIntersect(entries), {
          root: null,
          rootMargin: '-45% 0px -45% 0px',
          threshold: [0, 0.25, 0.5, 0.75, 1],
        });
        this.texts.forEach((text) => this.observer.observe(text));

        this.mobileObserver = new IntersectionObserver((entries) => this.onMobileIntersect(entries), {
          root: null,
          rootMargin: '0px 0px -10% 0px',
          threshold: 0.2,
        });
        this.watchMobileImages();
        this.sync();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.mobileObserver?.disconnect();
        this.desktop?.removeEventListener('change', this.onDesktopChange);
      }

      watchMobileImages() {
        if (!this.mobileObserver) return;
        this.mobileImages.forEach((image) => {
          if (image.classList.contains('is-visible')) return;
          this.mobileObserver.unobserve(image);
          this.mobileObserver.observe(image);
        });
      }

      onMobileIntersect(entries) {
        if (this.desktop.matches) return;
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          this.mobileObserver.unobserve(entry.target);
        });
      }

      sync() {
        const current = this.images.find((image) => image.classList.contains('is-active'));
        this.setActive(current?.dataset.step ?? this.texts[0]?.dataset.step ?? '0');
      }

      onIntersect(entries) {
        if (!this.desktop.matches) return;

        const hit = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (!hit) return;
        this.setActive(hit.target.dataset.step);
      }

      setActive(step) {
        this.images.forEach((image) => {
          const active = image.dataset.step === step;
          image.classList.toggle('is-active', active);
          image.toggleAttribute('inert', !active);
        });
      }
    }

    customElements.define('process-steps', ProcessSteps);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-feed"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('social-feed-marquee')) {
    class SocialFeedMarquee extends HTMLElement {
      connectedCallback() {
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.source = this.querySelector('[data-social-feed-source]');
        this.track = this.querySelector('[data-social-feed-track]');
        if (!this.track) return;

        if (this.dataset.mode === 'posts') {
          this.cloneGroup();
          if (!this.reduceMotion.matches) this.initMotion();
          return;
        }
        if (!this.source) return;

        this.onLoaded = () => this.schedule();
        document.addEventListener('instafeedAppLoaded', this.onLoaded);
        this.observer = new MutationObserver(() => this.schedule());
        this.observer.observe(this.source, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['src', 'poster', 'data-src', 'srcset', 'data-instafeed-src'],
        });
        this.schedule();
        if (!this.reduceMotion.matches) this.initMotion();
      }

      disconnectedCallback() {
        document.removeEventListener('instafeedAppLoaded', this.onLoaded);
        this.observer?.disconnect();
        clearTimeout(this.timer);
        cancelAnimationFrame(this.frame);
        this.resizeObserver?.disconnect();
        this.visibilityObserver?.disconnect();
      }

      // The track holds two identical groups; the offset wraps every group width to loop seamlessly.
      initMotion() {
        this.viewport = this.querySelector('.social-feed__viewport');
        if (!this.viewport) return;
        this.setAttribute('data-js', '');
        // Lenis (smooth-scroll.js) leaves horizontal wheel gestures here alone.
        this.viewport.setAttribute('data-lenis-prevent-horizontal', '');

        this.offset = 0;
        this.velocity = 0; // px per ms, from a released drag
        this.direction = this.dataset.direction === 'right' ? 1 : -1;
        this.duration = (parseFloat(getComputedStyle(this).getPropertyValue('--social-feed-duration')) || 50) * 1000;
        this.groupWidth = 0;
        this.visible = true;

        const measure = () => {
          this.groupWidth = this.track.firstElementChild?.offsetWidth || 0;
        };
        this.resizeObserver = new ResizeObserver(measure);
        this.resizeObserver.observe(this.track);
        measure();

        this.visibilityObserver = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting;
        });
        this.visibilityObserver.observe(this);

        this.viewport.addEventListener('pointerover', (event) => {
          if (event.pointerType === 'mouse') this.hovered = Boolean(event.target.closest('a.social-feed__item'));
        });
        this.viewport.addEventListener('pointerleave', () => {
          this.hovered = false;
        });

        // Drag / swipe. Pointer capture only once it's clearly a drag, so a
        // plain click still reaches the tile's link.
        this.viewport.addEventListener('pointerdown', (event) => {
          if (event.button !== 0) return;
          this.pointer = { id: event.pointerId, x: event.clientX, moved: 0, samples: [] };
          this.velocity = 0;
          // Browsers don't always fire a click after a captured drag; clear
          // the flag so it can't swallow this new press's click.
          this.suppressClick = false;
        });
        this.viewport.addEventListener('pointermove', (event) => {
          const pointer = this.pointer;
          if (!pointer || pointer.id !== event.pointerId) return;
          const dx = event.clientX - pointer.x;
          pointer.x = event.clientX;
          pointer.moved += Math.abs(dx);
          if (!this.dragging && pointer.moved > 6) {
            this.dragging = true;
            this.setAttribute('data-dragging', '');
            this.viewport.setPointerCapture(event.pointerId);
          }
          if (!this.dragging) return;
          this.offset += dx;
          pointer.samples.push({ dx, t: event.timeStamp });
          pointer.samples = pointer.samples.filter((sample) => event.timeStamp - sample.t < 100);
        });
        const release = (event) => {
          const pointer = this.pointer;
          if (!pointer || pointer.id !== event.pointerId) return;
          if (this.dragging) {
            const { samples } = pointer;
            const span = samples.length > 1 ? samples[samples.length - 1].t - samples[0].t : 0;
            const distance = samples.reduce((total, sample) => total + sample.dx, 0);
            this.velocity = span > 0 ? Math.max(-4, Math.min(4, distance / span)) : 0;
            this.suppressClick = true;
            this.dragging = false;
            this.removeAttribute('data-dragging');
          }
          this.pointer = null;
        };
        this.viewport.addEventListener('pointerup', release);
        this.viewport.addEventListener('pointercancel', release);
        // A drag that ends over a tile mustn't open it.
        this.viewport.addEventListener(
          'click',
          (event) => {
            if (!this.suppressClick) return;
            this.suppressClick = false;
            event.preventDefault();
            event.stopPropagation();
          },
          true
        );

        this.viewport.addEventListener(
          'wheel',
          (event) => {
            if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;
            event.preventDefault();
            this.offset -= event.deltaX;
            this.velocity = 0;
            this.wheelUntil = performance.now() + 600;
          },
          { passive: false }
        );

        let last = performance.now();
        const tick = (now) => {
          const dt = Math.min(now - last, 50);
          last = now;
          if (this.visible && this.groupWidth) {
            if (!this.dragging) {
              const idle = this.hovered || now < (this.wheelUntil || 0);
              const auto = idle ? 0 : (this.direction * this.groupWidth * dt) / this.duration;
              this.offset += auto + this.velocity * dt;
              this.velocity *= Math.pow(0.94, dt / 16);
              if (Math.abs(this.velocity) < 0.005) this.velocity = 0;
            }
            // Wrap into (-groupWidth, 0].
            const width = this.groupWidth;
            this.offset = (((this.offset % width) - width) % width) || 0;
            this.track.style.transform = `translate3d(${this.offset}px, 0, 0)`;
          }
          this.frame = requestAnimationFrame(tick);
        };
        this.frame = requestAnimationFrame(tick);
      }

      schedule() {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.build(), 80);
      }

      cloneGroup() {
        const group = this.track.querySelector('.social-feed__group:not([aria-hidden])');
        if (!group || !group.children.length) return;
        this.track.querySelectorAll('.social-feed__group[aria-hidden]').forEach((copy) => copy.remove());
        const copy = group.cloneNode(true);
        copy.setAttribute('aria-hidden', 'true');
        copy.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
        copy.querySelectorAll('[data-shopify-editor-block]').forEach((el) => el.removeAttribute('data-shopify-editor-block'));
        copy.querySelectorAll('a').forEach((link) => {
          link.tabIndex = -1;
        });
        this.track.append(copy);
      }

      // Instafeed lazy-loads: the real URL stays in data-instafeed-src while the hidden
      // source never scrolls into view, so read it first and skip the placeholder.
      mediaSource(media) {
        if (!media) return '';
        const candidates = [
          media.getAttribute('data-instafeed-src'),
          media.currentSrc,
          media.getAttribute('src'),
          media.getAttribute('data-src'),
          media.querySelector?.('source[src]')?.getAttribute('src'),
        ];
        return candidates.find((src) => src && !/\/assets\/img\/placeholder\./.test(src)) || '';
      }

      videoSource(video) {
        const src = this.mediaSource(video);
        return src && !src.startsWith('blob:') && !src.startsWith('data:') ? src : '';
      }

      collect() {
        const posts = [];
        const seen = new Set();

        // Instafeed adds a <video> only when its "autoplay videos" option is on; prefer it,
        // with the thumbnail as poster.
        const push = (href, image, video, thumbnail = '') => {
          if (!href || seen.has(href)) return;
          const videoSrc = this.videoSource(video);
          const imageSrc = this.mediaSource(image) || video?.getAttribute('poster') || thumbnail;
          const src = videoSrc || imageSrc;
          if (!src || src.startsWith('data:')) return;
          seen.add(href);
          posts.push({
            href,
            src,
            poster: videoSrc ? imageSrc : '',
            alt: image?.getAttribute('alt') || '',
            video: Boolean(videoSrc),
          });
        };

        this.source.querySelectorAll('a[href]').forEach((anchor) => {
          const thumbnail = anchor.closest('[data-instafeed-thumbnail]')?.getAttribute('data-instafeed-thumbnail') || '';
          push(anchor.href, anchor.querySelector('img'), anchor.querySelector('video'), thumbnail);
        });

        this.source.querySelectorAll('img, video').forEach((media) => {
          if (media.closest('a[href]')) return;
          const image = media.tagName === 'IMG' ? media : null;
          const video = media.tagName === 'VIDEO' ? media : null;
          push(this.mediaSource(media), image, video);
        });

        return posts;
      }

      group(posts, hidden) {
        const group = document.createElement('div');
        group.className = 'social-feed__group';
        if (hidden) group.setAttribute('aria-hidden', 'true');

        posts.forEach((post) => {
          const link = document.createElement('a');
          link.className = 'social-feed__item';
          link.href = post.href;
          link.target = '_blank';
          link.rel = 'noopener';
          if (hidden) link.tabIndex = -1;

          const media = document.createElement(post.video ? 'video' : 'img');
          if (post.video) {
            media.muted = true;
            media.loop = true;
            media.playsInline = true;
            media.preload = 'metadata';
            if (post.poster) media.poster = post.poster;
            media.autoplay = !this.reduceMotion.matches;
            media.setAttribute('aria-hidden', 'true');
            media.src = post.src;
          } else {
            media.src = post.src;
            media.alt = post.alt;
            media.loading = 'lazy';
            media.decoding = 'async';
          }

          link.append(media);
          group.append(link);
        });

        return group;
      }

      build() {
        const posts = this.collect();
        if (!posts.length) return;

        // src is part of the key so a tile rebuilds if its image only
        // resolves after the first pass.
        const key = posts.map((post) => `${post.href}:${post.video ? 'v' : 'i'}:${post.src}`).join('|');
        if (key === this.key) return;
        this.key = key;
        this.track.replaceChildren(this.group(posts, false), this.group(posts, true));
      }
    }

    customElements.define('social-feed-marquee', SocialFeedMarquee);
  }

  } catch(e) { console.error(e); }
})();
})();
